module.exports = __webpack_public_path__ + "b9f082f1e26ed26a5607c3059d4c3b0f.jpg";